import { render, staticRenderFns } from "./type122.vue?vue&type=template&id=3d013424&scoped=true"
import script from "./type122.vue?vue&type=script&lang=js"
export * from "./type122.vue?vue&type=script&lang=js"
import style0 from "./type122.vue?vue&type=style&index=0&id=3d013424&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d013424",
  null
  
)

export default component.exports